module.exports = __webpack_public_path__ + "media/images/official/special_sightseen-90cccece420838266dbeb35300152ac5.jpg";